import router from './router'
import store from './store'
import { CONFERENCE_ID_SPECIAL } from '@/utils/constant'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
// import { Message } from 'element-ui'
import { getToken, clearLoginData } from '@/utils/auth' // 验权
// import { checkToken } from '@/api/login'
NProgress.configure({ showSpinner: false })
// const whiteList = ['/login'] // 不重定向白名单
// router.beforeEach((to, from, next) => {
//   // NProgress.start()
//   if (getToken()) {
//     if (to.path === '/login') {
//       next({ path: '/' })
//      // NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
//     } else {
//       next()
//       // if (store.getters.roles.length === 0) {
//       //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
//       //     next()
//       //   }).catch((err) => {
//       //     store.dispatch('FedLogOut').then(() => {
//       //       // Message.error(err || 'Verification failed, please login again')
//       //       next({ path: '/' })
//       //     })
//       //   })
//       // } else {
//       //   next()
//       // }
//     }
//   } else {
//     if (whiteList.indexOf(to.path) !== -1) {
//       next()
//     } else {
//       // next()
//       next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
//       // NProgress.done()
//     }
//   }
// })

// router.afterEach(() => {
// // NProgress.done() // 结束Progress
// })
const whiteList = ['/login','/yjj-login', '/404', '/full-reg', '/invitation', '/n-invitation', '/n-reg1', '/n-reg2', '/n-login'] // 不重定向白名单
router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
  // console.log('to', to)
  // console.log('from', from)
  NProgress.start()
  // console.log(to)
  // gtag('config', 'UA-ID', {'page_path': to.fullPath});
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  // let brandId = ''
  if (to.name === 'inviteHasCode') {
    // removeToken()
    // localStorage.clear()
    // next({path: `/login?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}`, replace: true})
    // NProgress.done()
    // if (to.params.brand === '8' || to.params.brand === '9' || to.params.brand === '10' || to.params.brand === '116') {
    //   brandId = to.params.brand
    // } else {
    //   brandId = ''
    // }

    // 衣加加 => 订货会 start
    if (to.query.resource === 'yjjapp' && to.query.yjjphone ) {
      clearLoginData();
      store.commit('SET_WEBVIEW', 'yjjapp');
      if (to.query.yjjcode) {
        next({path: `/yjj-login?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}&logintype=login&loginphone=${to.query.yjjphone}&logincode=${to.query.yjjcode}`, replace: true})
      } else {
        next({path: `/login?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}&loginphone=${to.query.yjjphone}`, replace: true})
      }
      NProgress.done()
      
      // 衣加加 => 订货会  end

    } else if (to.query.inviteh5 === 'no') {
      next({path: `/login?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}&logintype=${to.query.logintype}`, replace: true})
      NProgress.done()
    } else if (to.params.conference == CONFERENCE_ID_SPECIAL) {
      next({path: `/n-invitation?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}`})
      NProgress.done()
    } else {
      
      // 跳转到h5邀请函
      // window.location.href = `${window.location.origin}/invite/#/params?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}`
      next({path: `/invitation?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}`})
      NProgress.done()
    }
    
  } else if (to.name === 'inviteNoCode') {
    // removeToken()
    // localStorage.clear()
    // next({path: `/login?brand=${to.params.brand}&conference=${to.params.conference}&from=${to.query.from}`, replace: true})
    // NProgress.done()
    // if (to.params.brand === '8' || to.params.brand === '9' || to.params.brand === '10' || to.params.brand === '116') {
    //   brandId = to.params.brand
    // } else {
    //   brandId = ''
    // }
    if (to.query.inviteh5 === 'no') {
      next({path: `/login?brand=${to.params.brand}&conference=${to.params.conference}&from=${to.query.from}&logintype=${to.query.logintype}`, replace: true})
      NProgress.done()
    } else if (to.params.conference == CONFERENCE_ID_SPECIAL) {
      next({path: `/n-invitation?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}`})
      NProgress.done()
    } else {
      // 跳转到h5邀请函
      // window.location.href = `${window.location.origin}/invite/#/params?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}`
      next({path: `/invitation?brand=${to.params.brand}&conference=${to.params.conference}&code=${to.params.code}&from=${to.query.from}`})
      NProgress.done()
    }
    
  } else if (getToken()) {
    store.dispatch('GetLocalUserInfo')
    if (to.path === '/login' || to.path === '/invitation' || to.path === '/n-invitation') {
      // let loginOnOff
      // if (store.state.user.conferenceList) {
      //   loginOnOff = store.state.user.conferenceList.some(item => {
      //     if (item.conferenceId === to.query.conference) { return true }
      //   })
      // }
      // if (loginOnOff) {
      //   next({path: '/', replace: true})
      //   NProgress.done()
      // } else {
      //   clearLoginData();
      //   next()
      // }
      next({path: '/', replace: true})
      NProgress.done()
    } else if (to.path === '/') {
      next({path: '/home', replace: true})
      NProgress.done()
      // if (store.state.user.conferenceList.length == 1) {
      //   sessionStorage.setItem('homepage_name', 'home')
      //   sessionStorage.setItem('selected_conferenceid', store.state.user.conferenceList[0].conferenceId)
      //   sessionStorage.setItem('selected_conference', store.state.user.conferenceList[0])
      //   next({path: '/home', replace: true})
      //   NProgress.done()
      // } else {
      //   sessionStorage.setItem('homepage_name', 'conference')
      //   next({path: '/conference', replace: true})
      //   NProgress.done()
      // }
    } else {
      next()
    }
  } else {
    clearLoginData();
    if (to.path === '/goodsdetail' && to.query.conference && to.query.itemId && to.query.brand) {
      next(`/login?brand=${to.query.brand}&conference=${to.query.conference}&logintype=login&redirect_url=goodsdetail`)
      NProgress.done()
    } else if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // next()
      next(`/404`)
      NProgress.done()
    }
  }

  router.afterEach(() => {
    NProgress.done() // 结束Progress
  })

  // if (getToken()) {
  //   if(to.path === '/login') {
  //     next({path: '/', replace: true})
  //   } else {
  //     let token = getToken()
  //     checkToken(token).then(response => {
  //       console.log(response)
  //       const data = JSON.parse(response.data)
  //       if ( response.erroyCode === 200 ) {
  //         next()
  //       }
  //       // setToken(data.token)
  //       // localStorage.setItem('user', data)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //  }
  // }
  // next() // 执行进入路由，如果不写就不会进入目标页
})



// WEBPACK FOOTER //
// ./src/permission.js